import SET_PRIMARY_INSURANCE from "../mutations/insurance/set-primary-insurance";

function editPrimaryInsuranceInfo(memberId, primaryInsuranceOptions, groupId, client) {
  return client.mutate({
    mutation: SET_PRIMARY_INSURANCE,
    fetchPolicy: 'no-cache',
    variables: { 
      memberId: memberId,
      primaryInsurance: primaryInsuranceOptions,
      groupId: groupId
    }
  });
}

export default editPrimaryInsuranceInfo;
